import styled from "@emotion/styled";
import bgImage from "../../assets/bgImage.png";

const LayoutStyle = styled.div({
  position: "relative",
  background: `url(${bgImage})`,
  objectFit: "cover",
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  backgroundAttachment: "fixed",
  backgroundPosition: "center center",

  "& .ant-menu-inline": {
    marginTop: "0",
    backgroundColor: "white",
    borderRight: "none",
  },

  "& .ant-menu-inline .ant-menu-item:after": {
    borderRight: "none",
  },

  //center logo of menubar
  "& .anticon": {
    verticalAlign: "-0.4em",
  },
  "& .ant-menu-item": {
    marginTop: "0",
  },
  "& .ant-layout": {
    background: "none",
  },
  "& .logouthover": {
    "& .anticon svg": {
      fill: "#244DA0",
    },
    ": hover": {
      backgroundColor: "#244DA0",
      color: "white",
      "& .anticon svg": {
        fill: "white",
      },
    },
  },
  "& .itemsList": {
    "& .ant-menu-item:not(.ant-menu-item-selected)": {
      backgroundColor: "white",
      "& .anticon": {
        fill: "#244DA0",
      },
      "& .customcss": {
        color: "#244DA0",
      },
      ":hover": {
        backgroundColor: "#244DA0",
        "& .anticon": {
          fill: "white",
        },
        "& .customcss": {
          color: "white",
        },
      },
    },
  },
  "& .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected": {
    backgroundColor: "#244DA0",
    "& .anticon": {
      fill: "white",
    },
    "& .customcss": {
      color: "white",
    },
  },

  "& .MainSider": {
    minWidth: "250px !important",
    height: "100vh",
    position: "relative",
    left: 0,
    top: 0,
    bottom: 0,
    backgroundColor: "white",
  },

  "& ant-btn ant-btn-primary  ": {
    borderColor: "#244DA0",
    borderRadius: "6px",
    backgroundColor: "#244DA0",
    fontWeight: "500",
  },

  "& .CompanyPolicy": {
    marginBottom: "1px !important",
  },
});

export default LayoutStyle;
